<div *ngIf="useToolbar" class="toolbar left">
  <dx-button icon='refresh' (onClick)="onRefresh()"></dx-button>
</div>
<div *ngIf="tabSelectedIndex === 0" class="toolbar">
  <dx-button icon="add" text="Add" (onClick)="onAdd()"></dx-button>
</div>
<div *ngIf="tabSelectedIndex !== 0" class="toolbar">
  <dx-button icon="close" text="Close" (onClick)="onCloseTab()"></dx-button>
</div>
<dx-tab-panel class="tab-list" [dataSource]="tabDataSource" [selectedIndex]="tabSelectedIndex" (onTitleClick)="onTitleClick($event)"></dx-tab-panel>
<dx-data-grid #datagriddx [visible]="tabSelectedIndex === 0"
              [dataSource]="dataSource"
              [columns]="columns"
              [rowAlternationEnabled]="true"
              [columnAutoWidth]="true"
              (onCellClick)="onCellClick($event)"
              (onRowInserting)="onRowInserting($event)"
              (onRowUpdating)="onRowUpdating($event)"
              (onRowRemoving)="onRowRemoving($event)"
              (onInitNewRow)="onInitNewRow($event)">
  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-editing mode="row"
               [allowUpdating]="allowUpdating"
               [allowDeleting]="allowDeleting"
               [allowAdding]="allowAdding"
               [useIcons]="true">
  </dxo-editing>
  <div *dxTemplate="let c of 'cellTemplate'">
    <dx-button icon="bookmark" (onClick)="onTabTemplateClick(c.data)"></dx-button>
  </div>
</dx-data-grid>
